import { preventDefault } from "@grrr/utils";
import animateScrollTo from "animated-scroll-to";

export const subMenu = function (el) {
    const subMenuElement = el.querySelector(".page-item__sub-menu");

    if (subMenuElement) {
        const subMenuLinks = subMenuElement.querySelectorAll("a");

        for (let j = 0; j < subMenuLinks.length; j++) {
            subMenuLinks[j].addEventListener("click", function (e) {
                if (this.href.indexOf("#") > -1) {
                    const id = this.href.substring(this.href.indexOf("#"));
                    const element = document.querySelector(id);

                    if (!element) {
                        return;
                    }

                    preventDefault(e);

                    let offset = -parseInt(
                        getComputedStyle(
                            document.querySelector(".topbar")
                        ).height.replace("px", "")
                    );

                    animateScrollTo(element, {
                        easing: (t) =>
                            t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
                        minDuration: 1000,
                        speed: 1000,
                        verticalOffset: offset,
                    });
                }
            });
        }
    }
};

export const smoothScroll = function (el) {
    const hash = window.location.hash.substring(1);
    if (hash && hash.length) {
        const element = document.querySelector("#" + hash);
        console.log(element, hash);
        let offset = 0;

        offset = -parseInt(
            getComputedStyle(document.querySelector(".topbar")).height.replace(
                "px",
                ""
            )
        );

        animateScrollTo(element, {
            easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
            minDuration: 1000,
            speed: 1000,
            verticalOffset: offset,
        });
    }
};
